import React from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { media, layout } from '@prisjakt/ui-base';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import ChevronRight from 'mdi-react/ChevronRightIcon';

const ellipsisWrapperMinWidth = 0;
const sharedStyleBreadcrumbs = css`
  display: flex;
  text-transform: uppercase;
  font-size: ${layout.fontSizes.small.desktop.rem};
  color: ${p => p.theme.text.tertiary};
  line-height: 1.2;
  min-width: ${ellipsisWrapperMinWidth};
`;

export const Breadcrumbs = styled.div`
  display: none;
  margin: 5px 10px;
  align-items: center;

  ${media.smallOnly`
    display: ${p => (p.mobile ? 'flex' : 'none')};
  `}

  ${media.mediumUp`
    display: ${p => (p.desktop ? 'flex' : 'none')};
  `}
`;

export const Crumb = styled(Link).attrs({ 'data-test': 'Crumb' })`
  align-items: center;
  font-weight: 400;
  ${sharedStyleBreadcrumbs};
`;

export const Current = styled.span.attrs({
  'data-test': 'Crumb',
  'data-test-type': 'current',
})`
  font-weight: bold;
  ${sharedStyleBreadcrumbs};
`;

export const Ellipsis = styled.span`
  display: inline;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const ArrowStyles = css`
  display: flex;
  width: 20px !important;
  height: 20px !important;
  margin-right: 7px;
  margin-left: ${p => (p.mobile ? 0 : '7px')};

  path {
    fill: ${p => p.theme.text.quaternary};
  }
`;

export const ArrowLeft = styled(({ mobile, theme, ...props }) => (
  <ChevronLeft {...props} />
))`
  ${ArrowStyles}
`;

export const ArrowRight = styled(({ mobile, theme, ...props }) => (
  <ChevronRight {...props} />
))`
  ${ArrowStyles}
`;

Breadcrumbs.propTypes = {
  mobile: PropTypes.bool,
  desktop: PropTypes.bool,
};

Breadcrumbs.defaultProps = {
  mobile: false,
  desktop: false,
};
